export default defineNuxtRouteMiddleware(async (to) => {
  if (import.meta.server) {
    return
  }
  const { ensureDeferredTranslations, ensureFullTranslations } = useTranslations('nothing')
  if (to.path === '/') {
    await ensureDeferredTranslations(to.path)
    return
  }
  await ensureFullTranslations()
})